import { onTrainActivity } from "common/signalR";
import ActivityPanel from "components/ActivityPanel/ActivityPanel";
import React from "react";
import { TrainActivityCard } from "./TrainActivityCard";
import { useCurrentUser } from "common/SessionContext";

interface Props {
  trainId: number
  config: server.dto.ActivityPanelConfig
}

export const TrainActivityPanel = (props: Props) => {
  const currentUser = useCurrentUser();

  return <ActivityPanel<server.dto.TrainActivity>
    activityKey="train"
    itemId={props.trainId}
    config={props.config}
    fetchActivities={(page, perPage) => window.CoreApi.Train.ListActivity({ itemId: props.trainId, page, perPage })}
    renderActivity={(activity => <TrainActivityCard
      key={activity.activityId}
      activity={activity}
    />)}
    onActivityRegisterFn={onTrainActivity}
    onActivity={(activity) => {
      const iAmActor = (activity.actor?.userId === currentUser.userId);

      return { refreshActivities: iAmActor };
    }}
  />
}
